<template>
  <div>
    <el-form-item label="发布范围" label-width="80px">
      <div class="vCenter rangeselect">
        <div class="vCenter">
          <el-radio class="elradio" v-model="formdapp.rangetype" label="0">仅个人可见（草稿）</el-radio>
          <el-radio class="elradio" v-model="formdapp.rangetype" label="1">所有人可见</el-radio>
          <el-radio
            class="elradio"
            v-model="formdapp.rangetype"
            label="2"
            @change="rangeChange"
          >范围可见</el-radio>
        </div>
        <div v-show="formdapp.rangetype=='2'">
          <el-button
            class="adduser"
            type="primary"
            plain
            size="small"
            @click="opencandidate('12378')"
          >选择</el-button>
        </div>
      </div>
      <div v-show="formdapp.rangetype=='2'">
        <div>
          <div>已选好友：</div>
          <div>
            <el-tag
              v-for="(item,index) in tagsFriend"
              :key="index"
              closable
              @close="handleClose(item,index,'f')"
            >{{item.name}}</el-tag>
          </div>
        </div>
        <div>
          <div>已选群组：</div>
          <div>
            <el-tag
              v-for="(item,index) in tagsGroup"
              :key="index"
              closable
              @close="handleClose(item,index,'g')"
            >{{item.name}}</el-tag>
          </div>
        </div>
        <div>
          <div>已选组织：</div>
          <div>
            <el-tag
              v-for="(item,index) in tagsOrg"
              :key="index"
              closable
              @close="handleClose(item,index,'o')"
            >{{item.name}}</el-tag>
          </div>
        </div>
        <div>
          <div>已选行业：</div>
          <div>
            <el-tag
              v-for="(item,index) in tagshy"
              :key="index"
              closable
              @close="handleClose(item,index,'h')"
            >{{item.name}}</el-tag>
          </div>
        </div>
        <div>
          <div>已选地区：</div>
          <div>
            <el-tag
              v-for="(item,index) in tagsdq"
              :key="index"
              closable
              @close="handleClose(item,index,'d')"
            >{{item.name}}</el-tag>
          </div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: "umRange",
  data() {
    return {};
  },
  props: ["formdapp", "tagsFriend", "tagsGroup", "tagsOrg", "tagshy", "tagsdq"],
  methods: {
    opencandidate(type) {
      this.$emit("opencandidate", type);
    },
    /**tag表签删除 */
    handleClose(item, index, type) {
      if (type == "f") {
        this.tagsFriend.splice(index, 1);
      } else if (type == "g") {
        this.tagsGroup.splice(index, 1);
      } else if (type == "o") {
        this.tagsOrg.splice(index, 1);
      } else if (type == "h") {
        this.tagshy.splice(index, 1);
      } else if (type == "d") {
        this.tagsdq.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// .addlist {
.rangeselect {
  // padding: 14px 0;
  height: 40px;
  justify-content: space-between;
}
// }
// .adduser {
//   font-size: 16px;
//   color: rgba(153, 153, 153, 1);
//   width: 80px;
//   height: 32px;
//   border: 1px solid rgba(204, 204, 204, 1);
//   border-radius: 4px;
//   text-align: center;
//   line-height: 30px;
//   cursor: pointer;
//   display: inline-block;
// }
</style>


// WEBPACK FOOTER //
// src/packages/range/um-range.vue